import { action, createRequestTypes } from '@/utils/actions.utils'
import { projectService } from '@/services'

export const GET_BUDGET_REQUEST_INFO = createRequestTypes('GET_BUDGET_REQUEST_INFO')
const getBudgetRequestInfo = ({ projectId, lang, catalogId }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId }))

			const res = await projectService.getBudgetRequestInfo({ projectId, lang, catalogId })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}
	function request(payload) {
		return action(GET_BUDGET_REQUEST_INFO.REQUEST, payload)
	}
	function success(payload) {
		return action(GET_BUDGET_REQUEST_INFO.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_BUDGET_REQUEST_INFO.FAILURE, null, err)
	}
}

export const GET_PROJECT_REGISTRATION = createRequestTypes('GET_PROJECT_REGISTRATION')
const getProjectRegistration = ({ projectId, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId }))

			const res = await projectService.getProjectRegistration({ projectId, lang })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}
	function request(payload) {
		return action(GET_PROJECT_REGISTRATION.REQUEST, payload)
	}
	function success(payload) {
		return action(GET_PROJECT_REGISTRATION.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_PROJECT_REGISTRATION.FAILURE, null, err, false)
	}
}

export const CREATE_PROJECT_REGISTRATION = createRequestTypes('CREATE_PROJECT_REGISTRATION')
const createProjectRegistration = ({ registrationData }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.createProjectRegistration({
				registrationData
			})
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}
	function request() {
		return action(CREATE_PROJECT_REGISTRATION.REQUEST)
	}
	function success(payload) {
		return action(CREATE_PROJECT_REGISTRATION.SUCCESS, payload)
	}
	function failure(err) {
		return action(CREATE_PROJECT_REGISTRATION.FAILURE, err)
	}
}

export const RESET_PROJECT_REGISTRATION_COMPLETED = 'RESET_PROJECT_REGISTRATION_COMPLETED'
const resetProjectRegistrationCompleted = () => {
	return action(RESET_PROJECT_REGISTRATION_COMPLETED)
}

const registrationActions = {
	getBudgetRequestInfo,
	getProjectRegistration,
	createProjectRegistration,
	resetProjectRegistrationCompleted
}

export default registrationActions
